import {Injectable} from '@angular/core';
import {HttpService, QueryModel} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {iResponseList} from '../../models/response/response.model';
import {AppointmentModel} from '../../models/appointment/appointment.model';

@Injectable({
    providedIn: 'root'
})
export class AppointmentService extends HttpService {

    getAppointments(query: QueryModel): Observable<iResponseList<AppointmentModel>> {
        return this.get('appointments/', query).pipe(
            map((response: iResponseList<AppointmentModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    patientCancelAppointment(appointmentId: string, patientId: string, reason: string): Observable<any> {
        return this.put(`patients/${patientId}/appointments/${appointmentId}/cancel`, {reason: reason}).pipe(
            map((response: any) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }
}
